import React from 'react';
import './App.css';
import { ThemeProvider } from '@material-ui/styles';

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import Authentication from './components/Authentication';
import RouteWithLayout from './components/RouteWithLayout';
import Layout from './components/Layout';
import { GlobalSnackBar } from './components/GlobalSnackBar';
import Businesses from './components/Businesses';
import Users from './components/Users/Users';
import Parameters from './components/Parameters';
import theme from './theme';
import Discussions from './components/Discussions/Discussions';
import UserProvider from './providers/UserProvider';
import Entities from './components/Entities';
import Enseignes from './components/Enseignes';
import ConfigsProvider from './providers/ConfigsProvider';
import Compaigns from './components/Compaigns/Compaigns';
import AllDiscussions from './components/AllDiscussions/allDiscussions';

const App = () => {
  return (
    <ConfigsProvider>
      <UserProvider>
        <ThemeProvider theme={theme}>
          <GlobalSnackBar />

          <Router>
            <Switch>
              <Redirect exact={true} from="/" to="/enseignes" />

              <Route
                {...{
                  path: '/login',
                  exact: true,
                  component: Authentication,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/businesses',
                  exact: true,
                  component: Businesses,
                  layout: Layout,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/users',
                  exact: false,
                  component: Users,
                  layout: Layout,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/discussions',
                  exact: false,
                  component: Discussions,
                  layout: Layout,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/compaigns',
                  exact: false,
                  component: Compaigns,
                  layout: Layout,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/parameters',
                  exact: true,
                  component: Parameters,
                  layout: Layout,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/entites',
                  exact: true,
                  component: Entities,
                  layout: Layout,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/enseignes',
                  exact: true,
                  component: Enseignes,
                  layout: Layout,
                }}
              />
              <RouteWithLayout
                {...{
                  path: '/allDiscussions',
                  exact: false,
                  component: AllDiscussions,
                  layout: Layout,
                }}
              />
            </Switch>
          </Router>
        </ThemeProvider>
      </UserProvider>
    </ConfigsProvider>
  );
};

export default App;
